module.exports = __webpack_public_path__ + "img/tag2.f9b58ea8.png";